<template>
  <div
    class="left-infosec d-flex align-items-center flex-wrap align-items-center justify-content-center text-center"
  >
    <div class="leftblock-wrap">
      <div v-if="!sharedEventId">
        <div class="info-detail">
          <h2>Create a Wish List for Every Occcasion</h2>
        </div>
        <div class="info-detail">
          
        </div>
      </div>
      <div v-else class="user-invitation">
        <div class="user-image">
          <!--<img src="assets/images/user.svg">-->
          <span class="user-bg"></span>
          <img
            :src="sharedEvent.image!=='undefined'?sharedEvent.image:'/img/defaultUser.8f379dba.png'"
            class="host-image"
            alt="image description"
            style="background-color: #f6cfe1;"
          />
        </div>
        <div class="info-detail">
          <h2>
            {{sharedEvent.hostName}} has
            <br />invited you to
            <br />
            {{sharedEvent.eventName}}
            Wish list
          </h2>
        </div>
      </div>
      <div class="store-link">
        <a target="_blank" href="https://apps.apple.com/au/app/white-bow-gift-registry/id1494432391"><img src="assets/images/appstore.png" /></a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      sharedEvent: null,
      sharedEventId: false
    };
  },
  created() {
    this.sharedEvent = JSON.parse(localStorage.getItem("sharedEvent"));
    this.sharedEventId = localStorage.getItem("sharedEventId");
    window.addEventListener("beforeunload", this.handler);
  },
  methods: {
    handler: function handler(event) {
      localStorage.removeItem("sharedEvent");
      localStorage.removeItem("sharedEventId");
    }
  }
};
</script>
